import { registerBlockType } from "@wordpress/blocks";
import metadata from "./block.json";
import Save from "./save";
import Edit from "./edit";
import deprecated from "./deprecated";

registerBlockType(metadata.name, {
  edit: Edit,
  save: Save,
  deprecated,
  icon: {
    foreground: "#0061FE",
    src: (
      <svg
        id="a"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path
          d="m19,3.8H6c-2.1,0-3.8,1.7-3.8,3.8v7.2c0,2.1,1.7,3.8,3.8,3.8h1.2v2.1c0,.3.1.5.4.6.1.1.2.1.4.1.1,0,.3,0,.4-.1l4.8-2.7h5.8c2.1,0,3.8-1.7,3.8-3.8v-7.3c0-2.1-1.7-3.7-3.8-3.7Zm2.2,10.9c0,1.2-1,2.2-2.2,2.2h-5.7c-.3,0-.6.1-.9.2l-3.7,2.1v-1.5c0-.4-.3-.8-.8-.8h-1.9c-1.2,0-2.2-1-2.2-2.2v-7.2c0-1.2,1-2.2,2.2-2.2h13c1.2,0,2.2,1,2.2,2.2v7.2Z"
          stroke-width="0"
        />
        <path
          d="m11.2,10.2l-1.3-.3c-.1,0-.2-.1-.2-.2l-.7-1h0c-.1-.2-.5-.2-.6,0l-.6,1c0,.1-.1.1-.2.2l-1.3.3c-.3.1-.4.3-.2.5l.9.9c0,.1.1.2,0,.3l-.1,1.2c0,.2.2.4.5.3l1.2-.4h.3l1.2.5c.2.1.5-.1.5-.3l-.1-1.2c0-.1,0-.2.1-.2l.9-.9c.1-.4,0-.7-.3-.7Z"
          stroke-width="0"
        />
        <path
          d="m16.5,11.9h-3c-.3,0-.6.3-.6.6s.3.6.6.6h3c.3,0,.6-.3.6-.6s-.3-.6-.6-.6Z"
          stroke-width="0"
        />
        <path
          d="m18.5,9.4h-5c-.3,0-.6.3-.6.6s.3.6.6.6h5c.3,0,.6-.3.6-.6s-.3-.6-.6-.6Z"
          stroke-width="0"
        />
      </svg>
    ),
  },
});
